import React from 'react';

import { Icon } from '../icons';

import DeliveryIcon from '../../icons/Delivery.svg';
import ExchangeIcon from '../../icons/Exchange.svg';
import OfficialStoreIcon from '../../icons/OfficialStore.svg';
import SecureIcon from '../../icons/Secure.svg';

import trads from './trads';

import { Wrapper } from './Guarantees.styles';

import { getLocaleSettings } from '../../utils/links';
import { useLocale } from '../../services/i18n/useLocale';

const Guarantees = ({ className }) => {
  const intl = useLocale();
  const settings = getLocaleSettings(intl.locale);

  if (!settings.shop) {
    return null;
  }

  return (
    <Wrapper className={className}>
      <div className="container">
        <div className="reinsurance">
          <h3 className="bigtitle">{intl.formatMessage(trads.garantee)}</h3>
          <ul>
            <li>
              <div className="icon-col">
                <Icon src={DeliveryIcon} />
              </div>
              <span>
                {intl.formatMessage(trads.freeShipping, {
                  strong: (val) => <strong>{val}</strong>,
                })}
              </span>
            </li>
            <li>
              <div className="icon-col">
                <Icon src={OfficialStoreIcon} />
              </div>
              <span>
                {intl.formatMessage(trads.official, {
                  strong: (val) => <strong>{val}</strong>,
                })}
              </span>
            </li>
            <li>
              <div className="icon-col">
                <Icon src={ExchangeIcon} />
              </div>
              <span>
                {intl.formatMessage(trads.exchange, {
                  strong: (val) => <strong>{val}</strong>,
                })}
              </span>
            </li>

            <li>
              <div className="icon-col">
                <Icon src={SecureIcon} />
              </div>
              <span>
                {intl.formatMessage(trads.secure, {
                  strong: (val) => <strong>{val}</strong>,
                })}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
};

export default Guarantees;
